import { useEffect, useRef } from "react";

let escapeHandlers = [];
let isListenerAttached = false;

const handleGlobalKeyDown = (event) => {
  if (event.key === "Escape" && escapeHandlers.length > 0) {
    // Find the handler with the highest level.
    // In case of a tie, favor the most recently added handler.
    let maxLevelHandler = escapeHandlers[escapeHandlers.length - 1];
    for (let i = escapeHandlers.length - 2; i >= 0; i--) {
      if (escapeHandlers[i].level > maxLevelHandler.level) {
        maxLevelHandler = escapeHandlers[i];
      }
    }

    if (maxLevelHandler && maxLevelHandler.callbackRef.current) {
      maxLevelHandler.callbackRef.current(event);
    }
  }
};

const useEscapeKey = (callback, isActive, level) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!isActive) return;

    if (!isListenerAttached) {
      document.addEventListener("keydown", handleGlobalKeyDown);
      isListenerAttached = true;
    }

    const handlerObj = { callbackRef, level };
    escapeHandlers.push(handlerObj);

    return () => {
      escapeHandlers = escapeHandlers.filter((h) => h !== handlerObj);

      if (escapeHandlers.length === 0 && isListenerAttached) {
        document.removeEventListener("keydown", handleGlobalKeyDown);
        isListenerAttached = false;
      }
    };
  }, [isActive, level]);
};

export default useEscapeKey;
